import styled from 'styled-components';

/** The "some attachments could not be read" note under an attachment list (both apps). */
export const Unreadable = styled.span`
	align-self: center;
	color: #b00020;
	font-size: 0.85rem;
`;

export default Unreadable;
